import {
  getAllTmsDataSetupGates,
  downloadDumpGateMaster,
} from '../../api/TMSDashboard/Setup';
const viewControl = {
  pageTitle: 'Setup',
  buckets: ['tms_setup_gates'],
  globalActions: [],
  fetchData: getAllTmsDataSetupGates,
  downloadData: downloadDumpGateMaster,
  filters: ['hub', 'gate_code', 'is_active'],
  isActiveOptionList: [
    { id: 'true', label: 'Active' },
    { id: 'false', label: 'Inactive' },
  ],
  actions: [
    {
      key: 'update',
      name: 'Update',
      isAllowed: (masterData) =>
        masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
          ?.transport?.gate?.update,
    },
    {
      key: 'addOptions',
      name: 'Add Options',
      isAllowed: (masterData) =>
        masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
          ?.transport?.gate?.update,
    },
    {
      key: 'pagination',
      name: 'Pagination',
    },
    {
      key: 'perPageCountChange',
      name: 'Pagination Count',
    },
    {
      key: 'download',
      name: 'Download',
    },
    {
      key: 'reload',
      name: 'Reload',
    },
  ],
  addOptions: [
    {
      key: 'add_single',
      title: 'Single',
      action: 'add',
      type: 'single',
    },
    {
      key: 'add_bulk',
      title: 'Bulk',
      action: 'add',
      type: 'bulk',
    },
  ],
};
const buckets = {
  tms_setup_gates: {
    name: 'Gates',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
